import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from './firebase';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logout = () => {
    return signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);

      if (user) {
        try {
          // Check if user is admin
          const tokenResult = await user.getIdTokenResult();
          const adminStatus = tokenResult.claims.admin === true;
          setIsAdmin(adminStatus);
          setRole(tokenResult.claims.role || null);
        } catch (error) {
          console.error('Error getting token:', error);
          setIsAdmin(false);
          setRole(null);
        }
      } else {
        setIsAdmin(false);
        setRole(null);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  // Accounts with role 'production' can only see the Production Line section.
  // Everyone else (admin/viewer/general access) can see everything.
  const isProductionOnly = role === 'production';

  const value = {
    currentUser,
    isAdmin,
    role,
    isProductionOnly,
    login,
    logout
  };


  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};